/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */

import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnInit,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';

export interface MitreTechniqueOption {
  techniqueId: string;
  techniqueName: string;
  tactic: string;
}

@Component({ standalone: false, 
  selector: 'mitre-multiselect',
  template: `
    <kendo-multiselect
      #multiselect
      [data]="filteredOptions"
      [filterable]="true"
      [(ngModel)]="selectedOptions"
      (ngModelChange)="onSelectionChange()"
      [textField]="'techniqueName'"
      placeholder="Search by technique name, technique id, or tactic"
      [valueField]="'techniqueId'"
      (filterChange)="handleFilterChange($event)"
      [popupSettings]="{ appendTo: 'component' }"
    >
      <ng-template kendoMultiSelectItemTemplate let-dataItem>
        <div class="technique-item">
          <span class="technique-id">{{ dataItem.techniqueId }}</span>
          <span>{{ dataItem.techniqueName }}</span>
          <span class="technique-tactic">{{ dataItem.tactic }}</span>
        </div>
      </ng-template>
      <ng-template kendoMultiSelectHeaderTemplate>
        <div class="technique-header">
          <span>Technique</span>
          <span>Technique Id</span>
          <span>Tactic</span>
        </div>
      </ng-template>
    </kendo-multiselect>
  `,
  styleUrls: ['./mitre-technique-multiselect.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MitreTechniqueMultiselectComponent),
      multi: true,
    },
  ],
})
export class MitreTechniqueMultiselectComponent
  implements ControlValueAccessor, OnInit
{
  @Input() public options: MitreTechniqueOption[] = [];
  @Output() public valueChange = new EventEmitter<MitreTechniqueOption[]>();
  @ViewChild('multiselect', { static: true })
  public multiselect!: MultiSelectComponent;

  public selectedOptions: MitreTechniqueOption[] = [];
  public filteredOptions: MitreTechniqueOption[] = [];

  // Callbacks to notify the form of changes
  public onChange: any = () => {};
  public onTouched: any = () => {};
  public value: any = null; // Holds the selected value

  public ngOnInit(): void {
    // Ensure filteredOptions is populated with the options
    this.filteredOptions = [...this.options];
  }

  public onSelectionChange(): void {
    // Emit the selected options when selection changes
    this.valueChange.emit(this.selectedOptions);
    // Notify the form model of the change
    this.onChange(this.selectedOptions);
  }

  public handleFilterChange(searchTerm: string): void {
    // If searchTerm is empty, show all options
    if (searchTerm) {
      this.filteredOptions = this.options.filter(
        (option) =>
          option.techniqueName
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          option.techniqueId.toLowerCase().includes(searchTerm.toLowerCase()) ||
          option.tactic.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    } else {
      // If no search term, show all options
      this.filteredOptions = [...this.options];
    }
  }

  public writeValue(obj: any): void {
    if (obj !== undefined) {
      this.selectedOptions = obj || [];
      this.filteredOptions = [...this.options]; // Reset filtered options
    }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
